import { render, staticRenderFns } from "./MainPrinter.vue?vue&type=template&id=bf20b9a4&scoped=true"
import script from "./MainPrinter.vue?vue&type=script&lang=js"
export * from "./MainPrinter.vue?vue&type=script&lang=js"
import style0 from "./MainPrinter.vue?vue&type=style&index=0&id=bf20b9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf20b9a4",
  null
  
)

export default component.exports